import _ from 'lodash';
import { ProductConfigurationResponse } from '../../../api/ConfigApi';
import { sortByObjectKey } from '../../../util/util';
import { SelectValue } from '../fields/ReactSelect';

export const getTypeOptionsByCategory = (
	category: string,
	productConfig: ProductConfigurationResponse,
) => {
	return productConfig.policyConfiguration.cancellations.reasons
		.filter(
			(reason) =>
				reason.name !== 'lapse' &&
				(reason.cancellationCategories
					? reason.cancellationCategories.includes(category)
					: false),
		)
		.map((reason) => ({
			value: reason.name,
			label: reason.title,
		})) as SelectValue[];
};

export const getCategoryOptions = (
	category: string,
	productConfig: ProductConfigurationResponse,
) => {
	if (!_.isEmpty(productConfig?.policyConfiguration?.cancellations?.reasons)) {
		const validReasons =
			productConfig.policyConfiguration.cancellations.reasons.filter(
				(reason) => reason.name !== 'lapse',
			);

		const allCategoryOptions = validReasons
			.filter((reason) => reason.cancellationCategories)
			.map((reason) => reason.cancellationCategories);

		const typeOptions = getTypeOptionsByCategory(category, productConfig);

		const catOptions = _.uniq(_.flattenDeep(allCategoryOptions)).map(
			(reason) => ({
				value: reason,
				label: reason,
			}),
		);

		return {
			categoryOptions: sortByObjectKey(catOptions, 'label'),
			categoryTypeOptions: sortByObjectKey(typeOptions, 'label'),
		};
	} else {
		return {
			categoryOptions: [],
			categoryTypeOptions: [],
		};
	}
};
